// Segmento del usuario: agrupa rol + etapa para adaptar el lenguaje y la
// estructura del home, el menú, el panel y el perfil ("cada capa habla de lo suyo").
//
//   internado    → estudiante con el internado EN CURSO: habla de internado y turno.
//   profesional  → enfermero/a (incluye docencia y postgrado): habla de turno.
//   estudiante   → estudiante en cualquier otra etapa (práctica de pregrado,
//                  internado por empezar o ya terminado, sin etapa): foco en
//                  aprender el PAE.
//   general      → sin rol todavía (perfil a medio hacer) o TENS, que tiene su
//                  propia capa (lib/tens.js) y no usa este copy.
//
// Desde el 2026-10-04 hay tres roles (lib/roles.js); el segmento
// docente_postgrado y el valor legado 'interno' se retiraron con ellos.

export function getSegmento(profile) {
  const rol = profile?.rol;
  const etapa = profile?.etapa_internado;

  if (rol === 'estudiante') {
    // Solo el internado EN CURSO habla como interno (A5/D8, 4-oct-2026; glosario
    // §0 de ops/playbooks/claridad-por-rol.md y ETAPAS_CON_TURNO en
    // lib/perfil.js). Quien empieza pronto o ya terminó no hace turnos: antes
    // el Home le decía "vive tus turnos" y la firma lo llamaba "interno".
    if (etapa === 'internado_en_curso') return 'internado';
    return 'estudiante'; // práctica de pregrado, pre o post internado, o sin etapa
  }
  if (rol === 'enfermero') return 'profesional';
  return 'general';
}

export const SEGMENTO_COPY = {
  internado: {
    eyebrow: 'Tu internado',
    titulo: 'Tu internado, paso a paso.',
    sub: 'Prepárate, vive tus turnos y cierra cada etapa con calma.',
  },
  profesional: {
    eyebrow: 'Tu turno',
    titulo: 'Tu vida en turno, ordenada.',
    sub: 'Prepara, registra y cierra cada turno en un solo lugar.',
  },
  estudiante: {
    eyebrow: 'Tu PAE',
    titulo: 'Tu PAE, con criterio.',
    sub: 'Practica tu proceso de enfermería paso a paso.',
  },
  general: {
    eyebrow: 'MiPAE',
    titulo: 'Explora MiPAE a tu ritmo.',
    sub: 'Razonamiento clínico, escalas y referencia en un solo lugar.',
  },
};

export function getSegmentoCopy(profile) {
  return SEGMENTO_COPY[getSegmento(profile)] || SEGMENTO_COPY.general;
}

// Frases cortas para el saludo del home (segunda línea), por segmento.
// Tono chileno, cálido y breve — estilo "Tu vida en turno, ordenada.".
export const SEGMENTO_TITULOS = {
  internado: [
    'Tu internado, paso a paso.',
    'Un turno a la vez, vas bien.',
    'Aquí se aprende haciendo.',
    'Tu internado, más liviano.',
    'De a poco, pero firme.',
  ],
  profesional: [
    'Tu vida en turno, ordenada.',
    'Tus herramientas para el turno.',
    'Un turno a la vez, bien hecho.',
    'Llega, ordena y anda tranquilo.',
    'Tu turno, bajo control.',
  ],
  estudiante: [
    'Tu PAE, con criterio.',
    'Aprende tu proceso, con calma.',
    'Paso a paso se arma el criterio.',
    'Tu PAE, sin apuro.',
  ],
  general: [
    'Explora MiPAE a tu ritmo.',
    'Mira lo que puede hacer MiPAE.',
    'Curiosea, sin compromiso.',
  ],
};

// Elige una frase del pool del segmento, estable durante la sesión.
export function getSegmentoTitulo(profile) {
  const seg = getSegmento(profile);
  const pool = SEGMENTO_TITULOS[seg] || SEGMENTO_TITULOS.general;
  const KEY = `mipae_titulo_home_${seg}`;
  try {
    const cached = sessionStorage.getItem(KEY);
    if (cached && pool.includes(cached)) return cached;
    const pick = pool[Math.floor(Math.random() * pool.length)];
    sessionStorage.setItem(KEY, pick);
    return pick;
  } catch {
    return pool[0];
  }
}
